(function () {
  var state = window.CatchmasterGA4 || {};
  var pushedLists = {};
  var expertAdviceImpressions = {};
  var expertAdviceViews = {};
  var checkoutInProgress = false;
  var recentAddToCart = {};
  var pendingAddToCartItems = {};
  var viewCartInProgress = false;
  var lastViewCartAt = 0;
  var expertAdviceTrackingVersion = 'expert_advice_v2';

  function getDataLayer() {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }

  function toNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : undefined;
  }

  function cleanParam(value, fallback) {
    value = value === undefined || value === null ? '' : String(value).trim();
    return value || fallback;
  }

  function pathHandle(pathname) {
    var path = cleanParam(pathname || window.location.pathname, '');
    var parts = path.split('/').filter(Boolean);
    return parts.length ? parts[parts.length - 1] : '';
  }

  function titleFromHandle(handle) {
    return cleanParam(handle, 'unknown').split('-').map(function (part) {
      return part.charAt(0).toUpperCase() + part.slice(1);
    }).join(' ');
  }

  function getLinkPath(link) {
    if (!link || !link.href) return '';

    try {
      return new URL(link.href, window.location.origin).pathname;
    } catch (error) {
      return '';
    }
  }

  function getArticleTitle() {
    if (state.article && state.article.article_title) return cleanParam(state.article.article_title, 'unknown_article');

    var heading = document.querySelector('main h1');
    return cleanParam(heading && heading.textContent, cleanParam(document.title, 'unknown_article'));
  }

  function getArticleTopic() {
    if (state.article && state.article.article_tag) return cleanParam(state.article.article_tag, 'unknown_topic');

    var topicLink = document.querySelector('main a[href*="/blogs/news/tagged/"], main a[href="/blogs/news"] + *');
    return cleanParam(topicLink && topicLink.textContent, 'unknown_topic');
  }

  function getArticleContext() {
    return {
      article_title: getArticleTitle(),
      article_url: cleanParam(state.article && state.article.article_url, window.location.pathname),
      article_tag: getArticleTopic(),
    };
  }

  function getNearestHeadingText(element) {
    var current = element;

    while (current && current !== document.body) {
      var previous = current.previousElementSibling;
      while (previous) {
        if (/^H[1-6]$/.test(previous.tagName)) {
          return cleanParam(previous.textContent, 'unknown_section');
        }

        var nestedHeading = previous.querySelector && previous.querySelector('h1, h2, h3, h4, h5, h6');
        if (nestedHeading) return cleanParam(nestedHeading.textContent, 'unknown_section');

        previous = previous.previousElementSibling;
      }

      current = current.parentElement;
    }

    return 'unknown_section';
  }

  function getArticleLinkType(link) {
    if (!link) return 'unknown_link';
    if (link.closest('[data-ga4-item]')) return 'product_card';
    if (link.querySelector('img')) return 'image';
    if (/read more/i.test(link.textContent || '')) return 'read_more';
    return 'text';
  }

  function getCollectionFallback() {
    return cleanParam(titleFromHandle(pathHandle()), 'unknown_collection');
  }

  function getCollectionHandleFallback() {
    return cleanParam(pathHandle(), 'unknown_collection');
  }

  function getExpertAdviceCardParams(card, link) {
    var articleTitle = cleanParam(card && card.getAttribute('data-ga4-article-title'), cleanParam(link && link.textContent, 'unknown_article'));
    var articleUrl = cleanParam(card && card.getAttribute('data-ga4-article-url'), link && getLinkPath(link) || 'unknown_url');

    return {
      collection_name: cleanParam(card && card.getAttribute('data-ga4-collection-title'), getCollectionFallback()),
      collection_handle: cleanParam(card && card.getAttribute('data-ga4-collection-handle'), getCollectionHandleFallback()),
      article_title: articleTitle,
      article_url: articleUrl,
      article_tag: cleanParam(card && card.getAttribute('data-ga4-article-tag'), 'unknown_topic'),
    };
  }

  function cleanItem(item) {
    if (!item) return null;

    var cleaned = {
      item_id: String(item.item_id || item.variant_id || item.id || ''),
      item_name: item.item_name || item.product_title || item.title || '',
      item_brand: item.item_brand || item.vendor || undefined,
      item_category: item.item_category || item.category || undefined,
      item_variant: item.item_variant || item.variant_title || undefined,
      price: toNumber(item.price),
      quantity: toNumber(item.quantity) || 1,
      index: toNumber(item.index),
      item_list_name: item.item_list_name || undefined,
    };

    if (!cleaned.item_id || !cleaned.item_name) return null;

    Object.keys(cleaned).forEach(function (key) {
      if (cleaned[key] === undefined || cleaned[key] === '') delete cleaned[key];
    });

    return cleaned;
  }

  function pushEvent(eventName, ecommerce) {
    if (!eventName || !ecommerce) return;

    getDataLayer().push({ ecommerce: null });
    getDataLayer().push({
      event: eventName,
      ecommerce: ecommerce,
    });
  }

  function pushMarketingEvent(eventName, params) {
    if (!eventName) return;

    var eventParams = Object.assign({
      page_path: window.location.pathname,
      page_title: document.title,
      tracking_version: expertAdviceTrackingVersion,
      tracking_source: 'theme',
      tracking_transport: 'data_layer',
    }, params || {});

    getDataLayer().push(Object.assign({
      event: eventName,
    }, eventParams));

    pushDirectGa4MarketingEvent(eventName, eventParams);
  }

  function pushDirectGa4MarketingEvent(eventName, params) {
    if (eventName.indexOf('expert_advice_') !== 0) return;
    if (!state.directMeasurementId) return;

    var directParams = Object.assign({}, params || {}, {
      tracking_transport: 'direct_collect',
    });
    var query = buildGa4CollectParams(eventName, directParams);
    if (!query) return;

    var url = 'https://www.google-analytics.com/g/collect?' + query;

    if (navigator.sendBeacon && navigator.sendBeacon(url)) return;

    if (window.fetch) {
      fetch(url, {
        method: 'GET',
        mode: 'no-cors',
        keepalive: true,
      }).catch(function () {});
      return;
    }

    var pixel = new Image();
    pixel.src = url;
  }

  function buildGa4CollectParams(eventName, params) {
    var clientId = getGaClientId();
    if (!clientId) return '';

    var searchParams = new URLSearchParams({
      v: '2',
      tid: state.directMeasurementId,
      cid: clientId,
      en: eventName,
      dl: window.location.href,
      dt: document.title,
      sid: getGaSessionId(),
      seg: '1',
      _p: String(Math.round(Math.random() * 2147483647)),
    });

    if (screen && screen.width && screen.height) {
      searchParams.set('sr', screen.width + 'x' + screen.height);
    }

    if (navigator.language) {
      searchParams.set('ul', navigator.language);
    }

    Object.keys(params || {}).forEach(function (key) {
      var value = params[key];
      if (value === undefined || value === null || value === '') return;
      searchParams.set('ep.' + key, String(value));
    });

    return searchParams.toString();
  }

  function getGaClientId() {
    var cookieMatch = document.cookie.match(/(?:^|;\s*)_ga=GA\d+\.\d+\.(\d+\.\d+)/);
    if (cookieMatch) return cookieMatch[1];

    try {
      var storedClientId = localStorage.getItem('catchmaster_ga4_client_id');
      if (storedClientId) return storedClientId;

      var clientId = Math.floor(Math.random() * 2147483647) + '.' + Math.floor(Date.now() / 1000);
      localStorage.setItem('catchmaster_ga4_client_id', clientId);
      return clientId;
    } catch (error) {
      return Math.floor(Math.random() * 2147483647) + '.' + Math.floor(Date.now() / 1000);
    }
  }

  function getGaSessionId() {
    var now = Math.floor(Date.now() / 1000);

    try {
      var session = JSON.parse(localStorage.getItem('catchmaster_ga4_session') || 'null');
      if (session && session.id && session.expiresAt && session.expiresAt > now) {
        session.expiresAt = now + 1800;
        localStorage.setItem('catchmaster_ga4_session', JSON.stringify(session));
        return String(session.id);
      }

      session = {
        id: now,
        expiresAt: now + 1800,
      };
      localStorage.setItem('catchmaster_ga4_session', JSON.stringify(session));
      return String(session.id);
    } catch (error) {
      return String(now);
    }
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    return String(url).indexOf('/cart/add') !== -1;
  }

  function getRequestUrl(input) {
    if (!input) return '';
    if (typeof input === 'string') return input;
    if (input.url) return input.url;
    return '';
  }

  function pushAddToCart(item) {
    if (!item) return;

    var key = item.item_id + ':' + item.quantity;
    var now = Date.now();
    if (recentAddToCart[key] && now - recentAddToCart[key] < 1500) return;
    recentAddToCart[key] = now;

    pushEvent('add_to_cart', {
      currency: state.currency,
      value: item.price * item.quantity,
      items: [item],
    });
  }

  function mergeItemFallback(item, fallback) {
    if (!item) return fallback || null;
    if (!fallback) return item;

    if (!item.item_category && fallback.item_category) item.item_category = fallback.item_category;
    if (!item.item_list_name && fallback.item_list_name) item.item_list_name = fallback.item_list_name;
    if (item.index === undefined && fallback.index !== undefined) item.index = fallback.index;
    return item;
  }

  function ajaxItemToGa4(item, fallback) {
    if (!item) return null;

    return mergeItemFallback(cleanItem({
      item_id: item.sku || item.variant_id || item.id,
      item_name: item.product_title || item.title,
      item_brand: item.vendor,
      item_category: item.product_type,
      item_variant: item.variant_title,
      price: item.final_price !== undefined ? item.final_price / 100 : item.price / 100,
      quantity: item.quantity,
    }), fallback);
  }

  function getCardItem(card, index) {
    if (!card) return null;

    return cleanItem({
      item_id: card.getAttribute('data-ga4-item-id'),
      item_name: card.getAttribute('data-ga4-item-name'),
      item_brand: card.getAttribute('data-ga4-item-brand'),
      item_category: card.getAttribute('data-ga4-item-category'),
      item_variant: card.getAttribute('data-ga4-item-variant'),
      item_list_name: card.getAttribute('data-ga4-list-name'),
      price: card.getAttribute('data-ga4-price'),
      quantity: 1,
      index: index,
    });
  }

  function getSelectedProductForm() {
    return document.querySelector('main product-form form[action*="/cart/add"], main form[action*="/cart/add"]');
  }

  function getProductVariantItem(variantId) {
    variantId = cleanParam(variantId, '');
    var variant = variantId && state.productVariants && state.productVariants[variantId];
    if (!variant || !state.product) return null;

    return cleanItem(Object.assign({}, state.product, variant));
  }

  function getSelectedProductItem() {
    var selectedItem = getProductVariantItem(getVariantInputValue(getSelectedProductForm()));
    return selectedItem || cleanItem(state.product);
  }

  function getFormItem(form) {
    if (!form) return null;

    var card = form.closest('[data-ga4-item]');
    var item = getCardItem(card);
    if (!item && state.product && form.closest('main')) item = getProductVariantItem(getVariantInputValue(form)) || cleanItem(state.product);
    if (!item) return null;

    var quantityInput = form.querySelector('[name="quantity"]');
    item.quantity = toNumber(quantityInput && quantityInput.value) || item.quantity || 1;
    return item;
  }

  function getVariantInputValue(form) {
    var variantInput = form && form.querySelector('[name="id"]');
    return cleanParam(variantInput && variantInput.value, '');
  }

  function recordPendingAddToCart(form) {
    var variantId = getVariantInputValue(form);
    if (!variantId) return;

    var item = getFormItem(form);
    if (!item) return;
    pendingAddToCartItems[variantId] = item;
  }

  function getPendingAddToCartItem(variantId) {
    variantId = cleanParam(variantId, '');
    return variantId ? pendingAddToCartItems[variantId] : null;
  }

  function trackViewItem() {
    if (!state.product) return;

    var item = getSelectedProductItem();
    if (!item) return;

    pushEvent('view_item', {
      currency: state.currency,
      value: item.price,
      items: [item],
    });
  }

  function trackViewItemLists() {
    var cards = getVisibleGa4Cards();
    if (!cards.length) return;

    var grouped = {};
    cards.forEach(function (card, index) {
      var item = getCardItem(card, index + 1);
      if (!item) return;

      var listName = item.item_list_name || 'Product List';
      if (!grouped[listName]) grouped[listName] = [];
      grouped[listName].push(item);
    });

    Object.keys(grouped).forEach(function (listName) {
      if (pushedLists[listName]) return;
      pushedLists[listName] = true;

      pushEvent('view_item_list', {
        item_list_name: listName,
        items: grouped[listName],
      });
    });
  }

  function trackSelectItem(event) {
    var link = event.target.closest('a[href]');
    if (!link) return;

    var card = link.closest('[data-ga4-item]');
    if (!card) return;

    var cards = getVisibleGa4Cards();
    var item = getCardItem(card, cards.indexOf(card) + 1);
    if (!item) return;

    pushEvent('select_item', {
      item_list_name: item.item_list_name || 'Product List',
      items: [item],
    });
  }

  function isVisibleGa4Item(card) {
    if (!card || card.closest('[hidden], [aria-hidden="true"], .hidden')) return false;

    var current = card;
    while (current && current !== document.documentElement) {
      var style = window.getComputedStyle && window.getComputedStyle(current);
      if (style && (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse')) return false;
      current = current.parentElement;
    }

    return true;
  }

  function getVisibleGa4Cards() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ga4-item]')).filter(isVisibleGa4Item);
  }

  function bindProductTabLists() {
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.tabs-slider-product-tabs [data-tab]')) return;
      window.setTimeout(trackViewItemLists, 0);
    }, true);

    document.addEventListener('keydown', function (event) {
      if (['ArrowRight', 'ArrowLeft', 'Home', 'End'].indexOf(event.key) === -1) return;
      if (!event.target.closest('.tabs-slider-product-tabs [data-tab]')) return;
      window.setTimeout(trackViewItemLists, 0);
    }, true);
  }

  function trackExpertAdviceTab(event) {
    var tab = event.target.closest('[data-ga4-expert-advice-tab]');
    if (!tab) return;

    var collectionHandle = cleanParam(tab.getAttribute('data-ga4-collection-handle'), getCollectionHandleFallback());
    if (expertAdviceViews[collectionHandle]) return;
    expertAdviceViews[collectionHandle] = true;

    pushMarketingEvent('expert_advice_view', {
      collection_name: cleanParam(tab.getAttribute('data-ga4-collection-title'), getCollectionFallback()),
      collection_handle: collectionHandle,
      section_id: cleanParam(tab.getAttribute('data-section-id'), 'unknown_section'),
    });
  }

  function trackExpertAdviceClick(event) {
    var link = event.target.closest('[data-ga4-expert-advice-link]');
    if (!link) return;

    var card = link.closest('[data-ga4-expert-advice-card]');
    if (!card) return;

    pushMarketingEvent('expert_advice_click', Object.assign(getExpertAdviceCardParams(card, link), {
      link_type: cleanParam(link.getAttribute('data-ga4-link-type'), 'unknown_link'),
    }));
  }

  function trackExpertAdviceImpression(card, index) {
    var params = getExpertAdviceCardParams(card);
    var key = [
      params.collection_handle,
      params.article_url,
      index,
    ].join(':');

    if (expertAdviceImpressions[key]) return;
    expertAdviceImpressions[key] = true;

    pushMarketingEvent('expert_advice_impression', Object.assign(params, {
      card_position: index,
    }));
  }

  function bindExpertAdviceImpressions() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-ga4-expert-advice-card]'));
    if (!cards.length || !window.IntersectionObserver) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var card = entry.target;
        var index = cards.indexOf(card) + 1;
        trackExpertAdviceImpression(card, index);
        observer.unobserve(card);
      });
    }, {
      threshold: 0.4,
    });

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  function isArticlePage() {
    return state.template === 'article' || window.location.pathname.indexOf('/blogs/news/') === 0;
  }

  function getArticleClickParams(link, destinationType) {
    var linkPath = getLinkPath(link);
    var linkHandle = pathHandle(linkPath);

    return Object.assign(getArticleContext(), {
      destination_type: destinationType,
      destination_url: cleanParam(linkPath, 'unknown_url'),
      destination_label: cleanParam(link && link.textContent, titleFromHandle(linkHandle)),
      destination_handle: cleanParam(linkHandle, 'unknown_destination'),
      link_type: getArticleLinkType(link),
      link_section: getNearestHeadingText(link),
    });
  }

  function isShopIntentPagePath(path) {
    return path.indexOf('/pages/best-') === 0 || path.indexOf('/pages/landing-page') === 0;
  }

  function trackExpertAdviceArticleShopClick(event) {
    if (!isArticlePage()) return;

    var link = event.target.closest('a[href]');
    if (!link || !link.closest('main')) return;

    var linkPath = getLinkPath(link);
    if (linkPath.indexOf('/products/') === 0) {
      pushMarketingEvent('expert_advice_article_product_click', getArticleClickParams(link, 'product'));
      return;
    }

    if (linkPath.indexOf('/collections/') === 0) {
      pushMarketingEvent('expert_advice_article_collection_click', getArticleClickParams(link, 'collection'));
      return;
    }

    if (isShopIntentPagePath(linkPath)) {
      pushMarketingEvent('expert_advice_article_cta_click', getArticleClickParams(link, 'page'));
    }
  }

  function trackExpertAdviceArticleAddToCart(event) {
    if (!isArticlePage()) return;

    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]') || !form.closest('main')) return;

    var variantInput = form.querySelector('[name="id"]');
    pushMarketingEvent('expert_advice_article_add_to_cart', Object.assign(getArticleContext(), {
      destination_type: 'add_to_cart',
      variant_id: cleanParam(variantInput && variantInput.value, 'unknown_variant'),
      link_section: getNearestHeadingText(form),
    }));
  }

  function trackAddToCartFromCartUpdate(event) {
    if (!event || event.source !== 'product-form' || !event.cartData) return;

    var item = ajaxItemToGa4(event.cartData, getPendingAddToCartItem(event.productVariantId));
    pushAddToCart(item);
    scheduleViewCart(150);
  }

  function trackAddToCartSubmit(event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;
    recordPendingAddToCart(form);
    if (form.closest('product-form')) return;

    var item = getFormItem(form);
    if (!item) return;

    pushAddToCart(item);
  }

  function trackCartAddResponse(data) {
    if (!data) return;

    var items = data.items && Array.isArray(data.items) ? data.items : [data];
    items.forEach(function (lineItem) {
      pushAddToCart(ajaxItemToGa4(lineItem, getPendingAddToCartItem(lineItem && lineItem.variant_id)));
    });
    scheduleViewCart(150);
  }

  function bindFetchCartAdd() {
    if (!window.fetch || window.fetch.__catchmasterGa4Patched) return;

    var originalFetch = window.fetch;
    window.fetch = function () {
      var requestUrl = getRequestUrl(arguments[0]);
      return originalFetch.apply(this, arguments).then(function (response) {
        if (isCartAddUrl(requestUrl) && response && response.ok) {
          response.clone().json().then(trackCartAddResponse).catch(function () {});
        }
        return response;
      });
    };
    window.fetch.__catchmasterGa4Patched = true;
  }

  function bindXhrCartAdd() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.__catchmasterGa4Patched) return;

    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__catchmasterGa4Url = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      this.addEventListener('load', function () {
        if (!isCartAddUrl(this.__catchmasterGa4Url) || this.status < 200 || this.status >= 300) return;

        try {
          trackCartAddResponse(JSON.parse(this.responseText));
        } catch (error) {}
      });

      return originalSend.apply(this, arguments);
    };

    window.XMLHttpRequest.__catchmasterGa4Patched = true;
  }

  function cartItemToGa4(item) {
    if (!item) return null;

    return cleanItem({
      item_id: item.sku || item.variant_id || item.id,
      item_name: item.product_title || item.title,
      item_brand: item.vendor,
      item_category: item.product_type,
      item_variant: item.variant_title,
      price: item.final_price !== undefined ? item.final_price / 100 : item.price / 100,
      quantity: item.quantity,
    });
  }

  function fetchCart() {
    if (!window.routes || !window.routes.cart_url) return Promise.resolve(null);

    return fetch(window.routes.cart_url + '.js', {
      headers: {
        Accept: 'application/json',
      },
    }).then(function (response) {
      return response.ok ? response.json() : null;
    }).catch(function () {
      return null;
    });
  }

  function pushCartEvent(eventName, cart) {
    var items = cart && cart.items ? cart.items.map(cartItemToGa4).filter(Boolean) : [];
    var value = cart && cart.total_price !== undefined ? cart.total_price / 100 : undefined;

    pushEvent(eventName, {
      currency: state.currency,
      value: value,
      items: items,
    });
  }

  function isCartPage() {
    return state.template === 'cart' || window.location.pathname.replace(/\/+$/, '') === '/cart';
  }

  function trackViewCart() {
    var now = Date.now();
    if (viewCartInProgress || now - lastViewCartAt < 1500) return;

    viewCartInProgress = true;
    lastViewCartAt = now;

    fetchCart().then(function (cart) {
      if (!cart) return;
      pushCartEvent('view_cart', cart);
    }).finally(function () {
      viewCartInProgress = false;
    });
  }

  function scheduleViewCart(delay) {
    if (!document.querySelector('cart-drawer') && !isCartPage()) return;
    window.setTimeout(trackViewCart, delay || 0);
  }

  function bindViewCart() {
    if (isCartPage()) trackViewCart();

    document.addEventListener('click', function (event) {
      var cartTrigger = event.target.closest('#cart-icon-bubble, a[href="/cart"], a[href$="/cart"]');
      if (!cartTrigger) return;

      scheduleViewCart(100);
    }, true);
  }

  // Re-resolve the live form at submit time. The cart drawer re-renders its footer
  // (and therefore the checkout button + form) on cart changes, so a form reference
  // captured at click time can be detached by the time we submit — submitting a
  // detached node is a silent no-op that strands the shopper. Prefer the button's
  // form attribute / closest live form over the captured one.
  function resolveCheckoutForm(form, button) {
    if (form && form.isConnected) return form;
    if (button) {
      var formId = button.getAttribute && button.getAttribute('form');
      if (formId) {
        var byId = document.getElementById(formId);
        if (byId) return byId;
      }
      if (button.form && button.form.isConnected) return button.form;
      if (button.closest) {
        var parentForm = button.closest('form');
        if (parentForm) return parentForm;
      }
    }
    return form || null;
  }

  function submitCheckout(form, button) {
    var liveForm = resolveCheckoutForm(form, button);
    if (liveForm) {
      var name = button && button.name;
      if (name && !liveForm.querySelector('input[name="' + name + '"]')) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = (button && button.value) || '';
        liveForm.appendChild(input);
      }
      liveForm.submit();
      return;
    }
    // No form (e.g. a plain checkout link) — navigate to its href instead of
    // re-clicking, which would re-enter this handler and loop.
    if (button && button.getAttribute) {
      var href = button.getAttribute('href');
      if (href) window.location.href = href;
    }
  }

  function trackBeginCheckout(event) {
    var button = event.target.closest('button[name="checkout"], input[name="checkout"], .upcart-checkout-button, [href*="/checkout"]');
    if (!button || checkoutInProgress) return;

    var form = button.form || (button.closest && button.closest('form'));
    checkoutInProgress = true;
    event.preventDefault();

    var done = false;
    function proceed() {
      if (done) return;
      done = true;
      // Release the latch so a later checkout click (bfcache back-nav, no-op submit)
      // is tracked again instead of being permanently ignored.
      checkoutInProgress = false;
      submitCheckout(form, button);
    }

    // Safety net: analytics must never block navigation. If fetchCart hangs, submit anyway.
    var fallbackTimer = setTimeout(proceed, 700);

    fetchCart().then(function (cart) {
      pushCartEvent('begin_checkout', cart);
    }).finally(function () {
      clearTimeout(fallbackTimer);
      proceed();
    });
  }

  function bindCartUpdate() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, trackAddToCartFromCartUpdate);
  }

  function init() {
    trackViewItem();
    trackViewItemLists();
    bindFetchCartAdd();
    bindXhrCartAdd();
    bindCartUpdate();
    bindViewCart();
    bindProductTabLists();
    bindExpertAdviceImpressions();

    document.addEventListener('click', trackSelectItem, true);
    document.addEventListener('click', trackExpertAdviceTab, true);
    document.addEventListener('click', trackExpertAdviceClick, true);
    document.addEventListener('click', trackExpertAdviceArticleShopClick, true);
    document.addEventListener('submit', trackExpertAdviceArticleAddToCart, true);
    document.addEventListener('submit', trackAddToCartSubmit, true);
    document.addEventListener('click', trackBeginCheckout, true);

    document.addEventListener('shopify:section:load', trackViewItemLists);
    document.addEventListener('shopify:section:load', bindExpertAdviceImpressions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
